module.exports = __webpack_public_path__ + "static/media/csvImage.a0bd986c.png";